import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  parse: (query) => client.post("/search/parse", { query }).then((r) => r.data),
  searchLeads: (payload) => client.post("/search/leads", payload).then((r) => r.data),
  getLeads: (params) => client.get("/leads", { params }).then((r) => r.data),
  getLead: (id) => client.get(`/leads/${id}`).then((r) => r.data),
  updateLead: (id, data) => client.patch(`/leads/${id}`, data).then((r) => r.data),
  deleteLead: (id) => client.delete(`/leads/${id}`).then((r) => r.data),
  bulkSave: (lead_ids) => client.post("/leads/bulk/save", { lead_ids }).then((r) => r.data),
  bulkStatus: (lead_ids, status) => client.post("/leads/bulk/status", { lead_ids, status }).then((r) => r.data),
  bulkTag: (lead_ids, tags) => client.post("/leads/bulk/tag", { lead_ids, tags }).then((r) => r.data),
  getLists: () => client.get("/lists").then((r) => r.data),
  getList: (id) => client.get(`/lists/${id}`).then((r) => r.data),
  createList: (name, description) => client.post("/lists", { name, description }).then((r) => r.data),
  deleteList: (id) => client.delete(`/lists/${id}`).then((r) => r.data),
  addToList: (id, lead_ids) => client.post(`/lists/${id}/add`, { lead_ids }).then((r) => r.data),
  removeFromList: (id, lead_ids) => client.post(`/lists/${id}/remove`, { lead_ids }).then((r) => r.data),
  stats: () => client.get("/dashboard/stats").then((r) => r.data),
  options: () => client.get("/meta/options").then((r) => r.data),
  exportListUrl: (id) => `${API}/export/list/${id}`,
  // settings
  getLlmSettings: () => client.get("/settings/llm").then((r) => r.data),
  saveLlmSettings: (data) => client.post("/settings/llm", data).then((r) => r.data),
  testLlmSettings: (data) => client.post("/settings/llm/test", data).then((r) => r.data),
  // saved searches
  getSearches: () => client.get("/searches").then((r) => r.data),
  createSearch: (data) => client.post("/searches", data).then((r) => r.data),
  deleteSearch: (id) => client.delete(`/searches/${id}`).then((r) => r.data),
};

export async function downloadSelectionCsv(lead_ids) {
  const res = await client.post("/export/selection", { lead_ids }, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = "leads_export.csv";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
